import { orderBy } from 'lodash';

import { HIGHLIGHT_MARK } from 'src/data/markedText';

export const APPROVAL_TYPE = {
  approved: 'approved',
  doNotUse: 'dont_use',
  doNotGenerate: 'dont_generate',
};

const APPROVAL_TYPE_PROPS = {
  [APPROVAL_TYPE.approved]: {
    title: 'Approved',
    description: 'We will show this definition and supporting information when we find this rule.',
  },
  [APPROVAL_TYPE.doNotUse]: {
    title: 'Flag',
    description:
      'We’ll flag. If a “Replace with” alternative is defined, we will suggest to use it instead.',
  },
  [APPROVAL_TYPE.doNotGenerate]: {
    title: 'Flag & Don’t generate',
    description:
      'We’ll refrain from generating. If this term is found in user created copy we will flag and suggest the “Replace with” term.',
  },
};

export const getApprovalTypeTitle = (type) => APPROVAL_TYPE_PROPS[type]?.title;
export const getApprovalTypeDescription = (type) => APPROVAL_TYPE_PROPS[type]?.description;
export const isNegativeType = (type) =>
  [APPROVAL_TYPE.doNotUse, APPROVAL_TYPE.doNotGenerate].includes(type);

export const isActiveNegativeBrandTerm = (brandTerm) =>
  brandTerm?.enabled && isNegativeType(brandTerm?.approvalType);

export const sortBrandTerms = (tools) =>
  orderBy(tools, ['updatedAt', 'term', 'id'], ['desc', 'asc', 'asc']);

export const mapDetectedBrandTermToHighlightingMark = (item) => ({
  type:
    item.brandTerm?.approvalType === APPROVAL_TYPE.doNotUse ||
    item.brandTerm?.approvalType === APPROVAL_TYPE.doNotGenerate
      ? HIGHLIGHT_MARK.warning
      : HIGHLIGHT_MARK.positive,
  paragraph: item.termParagraphIdx,
  start: item.termStartPosition,
  end: item.termEndPosition,
});
